import {FC} from 'react'

type Props = {
  className: string
}

const ListsWidget26: FC<Props> = ({className}) => {
  const topOccupations = [
    {
      code: '47-2061',
      title: 'Construction Laborers',
      total: 28731,
      existing: 28171,
      demand: 5128,
      growth: 'High',
      training: 'On the Job Training',
      trainingDuration: '3234 hours',
    },
    {
      code: '47-2111',
      title: 'Electricians',
      total: 18580,
      existing: 18580 - 4068,
      demand: 4068,
      growth: 'High',
      training: 'Apprenticeship',
      trainingDuration: '2172 hours',
    },
    {
      code: '47-1011',
      title: 'First-Line Supervisors of Construction Trades and Extraction Workers',
      total: 22834,
      existing: 22834 - 3046,
      demand: 3046,
      growth: 'High',
      training: 'Work Experience',
      trainingDuration: '74 hours',
    },
    {
      code: '49-9021',
      title: 'Heating, Air Conditioning, and Refrigeration Mechanics and Installers',
      total: 8047,
      existing: 8047 - 2712,
      demand: 2712,
      growth: 'High',
      training: 'Apprenticeship',
      trainingDuration: '646 hours',
    },
    {
      code: '47-2152',
      title: 'Plumbers, Pipefitters, and Steamfitters',
      total: 10974,
      existing: 10974 - 1826,
      demand: 1826,
      growth: 'High',
      training: 'Apprenticeship',
      trainingDuration: '-636 hours', // Please confirm this value
    },
  ]

  return (
    <div className={`card card-flush ${className}`}>
      <div className='card-header pt-5'>
        <span className='pt-1 fs-2 fw-bold text-dark me-2 lh-1 ls-n2'>
          Top 5 Occupations Needed:
        </span>
      </div>
      <div className='card-body'>
        {topOccupations.map((occupation, index) => (
          <div key={index} className='d-flex justify-content-between mb-2'>
            <span className='text-gray-500 flex-grow-1 me-4'>{occupation.title}</span>
            <span className='fw-bolder text-gray-700'>{occupation.demand.toLocaleString()}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export {ListsWidget26}
